/**
 * Safe JSON parsing and localStorage utilities.
 * Protects against '"undefined" is not valid JSON' runtime crashes when
 * localStorage contains the literal string 'undefined' or corrupted JSON.
 */

export const safeJsonParse = (value, fallback = null) => {
  if (!value || value === 'undefined' || value === 'null') return fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const safeLocalStorageGet = (key, fallback = null) => {
  try {
    const raw = localStorage.getItem(key);
    return safeJsonParse(raw, fallback);
  } catch {
    return fallback;
  }
};

export const safeLocalStorageSet = (key, value) => {
  try {
    if (value === undefined || value === null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
    }
  } catch {
    // Ignore storage quota or permission errors
  }
};
